import nav from './modules/nav';
import scrollToTop from './modules/scroll-to-top';
import loadMore from './modules/load-more';

nav();
scrollToTop();
loadMore();



// WEBPACK FOOTER //
// ./src/scripts/app.js